export type Oth360LeaderProfileResponse = {
  result: {
    evaluationRoundId?: string;
    roundId?: string;
    trust: { employeesAvg: number; employeesCount: number };
    gapAnalysis: {
      self: Record<string, number>;
      employeesAvg: Record<string, number>;
      employeesCount: number;
    };
    text: {
      continueWith: string[];
      stopWith: string[];
      startWith: string[];
    };
  };
};

export type Oth360LeaderProfile = Oth360LeaderProfileResponse['result'];

export type Oth360LeaderProfileError = { code?: string; message?: string };

export async function getOth360LeaderProfile(input: {
  mode: 'SELF';
}): Promise<
  | { ok: true; data: Oth360LeaderProfile }
  | { ok: false; status: number; error: Oth360LeaderProfileError | null }
> {
  const url = new URL('/api/oth/360/leader-profile', window.location.origin);
  url.searchParams.set('mode', input.mode);

  const res = await fetch(url.toString(), {
    method: 'GET',
    credentials: 'include',
    headers: { Accept: 'application/json' },
    cache: 'no-store',
  });

  if (res.ok) {
    const data = (await res.json()) as Oth360LeaderProfileResponse;
    return { ok: true, data: data.result };
  }

  let error: Oth360LeaderProfileError | null = null;
  try {
    error = (await res.json()) as Oth360LeaderProfileError;
  } catch {
    // ignore
  }

  return { ok: false, status: res.status, error };
}
